import React from 'react';
import { NavLink } from 'react-router-dom';
import { NavItem } from 'reactstrap';

import { quotesOrOpportunities } from '../utils';
import NavItemMore from './NavItemMore';

function PCNavigation() {
  return (
    <>
      <NavItem>
        <NavLink
          className="nav-link"
          to="/opportunities"
          isActive={quotesOrOpportunities}
        >
          Opportunities
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink className="nav-link" to="/campaigns">
          Campaigns
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink className="nav-link" to="/benchmarks">
          Benchmarks
        </NavLink>
      </NavItem>
      {/*       <NavItem>
        <NavLink className="nav-link" to="/sku-search">
          SKUs
        </NavLink>
      </NavItem> */}
      <NavItemMore
        items={[
          { text: 'Brands', href: '/brands' },
          { text: 'Contacts', href: '/contacts' },
          { text: 'Invoices', href: '/invoices' },
          { text: 'Users', href: '/users' },
          { text: 'Ad Manager Merchants', href: '/merchants' },
          { text: 'Merchant Attribution', href: '/merchant-attribution' },
        ]}
      />
    </>
  );
}

export default PCNavigation;
